import { Box, Divider, Grid, Container, ThemeProvider, Typography, Stack, Card, Link } from "@mui/material";
import Layout from "../components/Layout";
import "../components/NoteModal/Note.css";
import Note from "../components/NoteModal/Note";
import NewNote from "../components/NoteModal/NewNoteModal";
import React, { useRef, useState, useEffect, Fragment } from "react";
import Checklist from "../components/checklists/Checklist";
import ChecklistQues from "../components/checklists/ChecklistQues";
import "./pageStyle/MyStuff.css";
import html2pdf from 'html2pdf.js';
import {
  mystuff_page_title_subtitles,
  mystuff_page_questions_list,
  global_API,
  myValue_lastChoices,
} from "../utils/types";
import EnvelopeIcon from '../siteImages/icons/envelope-icon.svg';
import DownloadIcon from '../siteImages/icons/download-icon.svg';
import { REACT_APP_api_base_url, DEFAULT_LANGUAGE } from "../utils/url_config";
import jsPDF from "jspdf";
import axios from "axios";
import {
  Clock,
} from '@phosphor-icons/react'
import html2canvas from "html2canvas";
import { StyledEngineProvider } from "@mui/material/styles";
import Loading from '../components/Loading';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import { useNavigate, useLocation } from 'react-router-dom';
import PageBreak from '../components/PageBreak/PageBreak';

import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Buffer } from "buffer";

import { styled } from '@mui/material/styles';
import Button, { ButtonProps } from '@mui/material/Button';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box className="box-wrapper" sx={{ pt: 3, px: 0 }}>
          {children}
        </Box>
      )}
    </div>
  );
}
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
export default function MyStuff() {
  const lightGreen = '#dff0d8';
  const [sameSection, setSameSection] = useState<mystuff_page_questions_list>();
  const [pageTitlesData, setPageTitlesData] =
    useState<mystuff_page_title_subtitles>();
  const [notes, setNote] = useState([""]);
  const [modalShow, setModalShow] = useState(false);
  const [noteIndex, setIndex] = useState(0);
  const summaryGridRef = useRef<HTMLDivElement | null>(null);
  const [isPdfGeneration, setIsPdfGeneration] = useState(false);
  const [isloading, setLoading] = useState(false);
  const [languageState, setLanguageState] = useState(localStorage.getItem("language") || "ar");
  const [value, setValue] = React.useState(0);

  const [email, setEmail] = useState('');
  const [isEmailValid, setEmailValid] = useState(true);

  const [isMobile, setIsMobile] = useState(false);
  const [width, setWidth] = useState<number>(window.innerWidth);
  const [globalData, setGlobalData] = useState<global_API>();
  const [lastQuestionChoices, setLastQuestionChoices] = useState<myValue_lastChoices>();
  
  const navigate = useNavigate();
  const location = useLocation();

  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    if (width <= 768) {
      setIsMobile(true)
    }
  }, [width]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    navigate(`/MyStuff?tab=${newValue}`);
  };

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabValue = params.get('tab');
    if (tabValue) {
      setValue(Number(tabValue));
    }
  }, [location.search]);

  const addNote = function (value: string) {
    return setNote((notes) => [...notes, value]);
  };
  const deleteNote = (index: any) => {
    notes.splice(index, 1);
    setNote((notes) => [...notes]);
  };

  //note is deleted using splice feature, splice returns orifinal notes index, prior to addition
  const editNote = (value: string) => {
    notes.splice(noteIndex, 1);
    setNote((notes) => [...notes, value]);
  };

  //using feature, edits previousy created notes, and pushes new notes (from index where edits happened) to notes array
  const editNoteIndex = (index: any) => {
    setIndex(index);
  };

  useEffect(() => {
    window.addEventListener("storage", () => {
      setLanguageState(localStorage.getItem("language") || "ar");
    });
  }, []);


  const downloadSummary = () => {
    setIsPdfGeneration(true);
    setLoading(true);
    const element = document.getElementById('pdf-page');

    // Check if the element is found
    if (!element) {
      console.error("Element with ID 'pdf-page' not found");
      setIsPdfGeneration(false);
      setLoading(false);
      return;
    }

    const images = element.querySelectorAll('img');

    const loadImagePromises = Array.from(images).map(
      (img): Promise<void> =>
        new Promise((resolve, reject) => {
          if (img.complete) {
            resolve();
          } else {
            img.onload = () => resolve();
            img.onerror = (error) => reject(error);
          }
        })
    );

    Promise.all(loadImagePromises)
      .then(() => {
        var options = {
          margin: 0,
          enableLinks: false,
          filename: 'PartnertoDecide.pdf',
          image: { type: 'jpeg', quality: 0.75 },
          css: 'custom-styles',
          html2canvas: {
            scale: 2,
            useCORS: true,
            proxy: 'https://arabic-strapi-backend-mffju.ondigitalocean.app', // Replace with the URL of your CORS proxy server
          },
          jsPDF: {
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4',
          },
        };
        window.setTimeout(() => {
          html2pdf().set(options).from(element).save().then(() => {
            setIsPdfGeneration(false);
            setLoading(false);
          });
        }, 1000);
      })
      .catch((error) => {
        console.error('Error loading images:', error);
        setIsPdfGeneration(false);
        setLoading(false);
      });
  };


  useEffect(() => {
    const fetchPageTitlesData = async () => {
      try {
        const result = await axios.get(REACT_APP_api_base_url +
          "/api/my-stuff-page-title?populate=deep&locale=" +
          localStorage.getItem("language")
        );
        setPageTitlesData(result.data);
      } catch (error) {
        console.error("Error fetching learn about data: ", error);
        try {
          const result = await axios.get(REACT_APP_api_base_url +
            "/api/my-stuff-page-title?populate=deep&locale=" +
            DEFAULT_LANGUAGE
          );
          setPageTitlesData(result.data);
        } catch (error) {
          console.error(
            "Error fetching learn about data with default locale: ",
            error
          );
        }
      }
    };
    const fetchSameSection = async () => {
      try {
        const result = await axios.get(REACT_APP_api_base_url +
          "/api/my-stuff-questions?populate=deep&locale=" +
          localStorage.getItem("language")
        );
        const sortedData = result.data.data.sort((a: any, b: any) => {
          return a.id - b.id;
        });
        setSameSection(result.data);
      } catch (error) {
        console.error("Error fetching learn about data: ", error);
        try {
          const result = await axios.get(REACT_APP_api_base_url +
            "/api/my-stuff-questions?populate=deep&locale=/api/my-choices-same?populate=deep&locale=" +
            DEFAULT_LANGUAGE
          );
          setSameSection(result.data);
        } catch (error) {
          console.error(
            "Error fetching learn about data with default locale: ",
            error
          );
        }
      }
    };
    const fetchglobalData = async () => {
      try {
        const result = await axios.get( REACT_APP_api_base_url +
          "/api/global-translation-api?populate=deep&locale=" +
          localStorage.getItem("language")
        );
        setGlobalData(result.data);
      } catch (error) {
        console.error("Error fetching learn about data: ", error);
        try {
          const result = await axios.get( REACT_APP_api_base_url +
            "/api/global-translation-api?populate=deep&locale=" +
              DEFAULT_LANGUAGE
          );
          setGlobalData(result.data);
        } catch (error) {
          console.error(
            "Error fetching learn about data with default locale: ",
            error
          );
        }
      }
    };

    const fetchLastQuestionChoices = async () => {
      try {
        const result = await axios.get( REACT_APP_api_base_url +
          "/api/my-values-last-question-choice?populate=deep&locale=" +
          localStorage.getItem("language")
        );
        setLastQuestionChoices(result.data);
      } catch (error) {
        console.error("Error fetching questions choices data: ", error);
        try {
          const result = await axios.get( REACT_APP_api_base_url +
            "/api/my-values-last-question-choice?populate=deep&locale=" +
              DEFAULT_LANGUAGE
          );
          setLastQuestionChoices(result.data);
        } catch (error) {
          console.error(
            "Error fetching questions choices with default locale: ",
            error
          );
        }
      }
    };  
    fetchLastQuestionChoices();

    fetchglobalData();
    fetchSameSection();
    fetchPageTitlesData();
  }, [languageState]);

  const storedRating = localStorage.getItem('QuizQuestions') || '';
  let rating;
  if (storedRating) {
    rating = JSON.parse(storedRating);
  }

  const renderArray = (arr: string[]) => {
    if (arr.length === 0) {
      return;
    }
    return arr.map((item, index) => (
      <React.Fragment key={index}>
        <span>{item}</span>
        {index !== arr.length - 1 && <span style={{ margin: "0 20px" }}></span>}
      </React.Fragment>
    ));
  };

  const validateEmail = (email) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    setEmailValid(validateEmail(newEmail));
  };

  const handleEmailSend = async () => {
    setLoading(true);
    setIsPdfGeneration(true);
    const element = document.getElementById('pdf-page');
    var pdfOptions = {
      margin: 0,
      enableLinks: false,
      filename: 'PartnertoDecide.pdf',
      image: { type: 'jpeg', quality: 0.75 },
      css: 'custom-styles',
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: {
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
      }
    };
    setTimeout(async () => {
      try {
        const pdfBlob = await html2pdf().from(element).set(pdfOptions).outputPdf('blob');
        const pdfContent = await new Response(pdfBlob).arrayBuffer();
        const attachment = [
          {
            content: Buffer.from(new Uint8Array(pdfContent)).toString('base64'),
            filename: 'PartnertoDecide.pdf',
            type: 'application/pdf',
            disposition: 'attachment',
          },
        ];

        console.log('attachment', attachment);
        setIsPdfGeneration(false);
        const response = await axios.post(
          `${REACT_APP_api_base_url}/api/email/send`,
          {
            email: email,
            subject: `${pageTitlesData?.data.attributes.Email_Subject}`,
            text: `${pageTitlesData?.data.attributes.Email_Content}`,
            fromName: `${pageTitlesData?.data.attributes.Email_From}`,
            fileURL: attachment,
          }
        );
        setLoading(false);
        setOpen(false);
      } catch (error) {
        console.error('Error sending email:', error);
      }
    }, 2000);
  };


  const WhiteStyleButton = styled(Button)<ButtonProps>(({ theme }) => ({
    color: '#0C3A25',
    backgroundColor: 'white',
    borderRadius: '20px',
    px: 3,
    py: 1,
    textTransform: 'capitalize',
    fontSize: '1.125rem',
    '&:hover': {
      backgroundColor: '#F4FCF0',
    },
  }));


  return (
    <StyledEngineProvider injectFirst>
      {isloading == true &&
        <Loading />
      }
      <Layout>
        <div>
          <Grid container columns={{ xl: 12, lg: 12, md: 12 }} item xl={12} lg={12} md={12}
            sx={{
              backgroundColor: "#FAF6ED", direction: "column",
              mt: 0, pt: 8, pb: 0, display: "flex", alignItems: "center", justifyContent: "center"
            }} >
            <Grid item xs={12}>
              <Container maxWidth="md">
                <Box>
                  <Tabs className="tabs-head" value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label={pageTitlesData?.data.attributes.Tab1Heading} {...a11yProps(0)} />
                    <Tab label={pageTitlesData?.data.attributes.Tab2Heading} {...a11yProps(1)} />
                  </Tabs>
                </Box>
              </Container>

              <div id="pdf-page" ref={summaryGridRef} style={{ backgroundColor: '#FAF6ED', width: '100%', paddingLeft: '0', paddingRight: '0' }}>
                {isPdfGeneration == true &&
                  <>
                    <Grid container sx={{ display: 'flex', justifyContent: 'center', paddingTop: '2rem', marginBottom: '2rem' }} className="nav-logo">
                      <img
                        className="nav"
                        src="data:image/svg+xml;base64,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"
                        crossOrigin="anonymous"
                        alt="Logo"
                        width="170px"
                        height="20px"
                      />
                    </Grid>
                    <Typography variant="h3" fontSize="2.25rem" mb="2.4rem" color="primary.main" textAlign="center">
                      {pageTitlesData?.data.attributes.PdfMyValues}
                    </Typography>

                    <Grid item xs={12} pl={!isMobile ? "0rem" : ""} pr={!isMobile ? "0rem" : ""} sx={{ alignItems: "center" }}>

                      {rating &&
                        <Grid
                          container
                          columns={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}
                        >
                          <div className="summary-grid if-summary" >
                            {rating.mostImportant.length > 0 &&
                              <div className="summary-box most-important">
                                <Typography variant="h3" fontSize="2.25rem" mb="2.4rem" color="primary.main">
                                  {pageTitlesData?.data.attributes.MostImportant}
                                </Typography>
                                <Stack direction="row" flexWrap="wrap" justifyContent="center">
                                  {rating.mostImportant.map((cur, index) => {
                                    return (
                                      <Grid item width='158px' sx={{ p: 2 }} textAlign="center">
                                        {cur['icon'] ?
                                          <Box className="icon-shape">
                                            <img className="values-icon" style={{ width: 50 }} src={cur['icon']} alt="" />
                                          </Box>
                                          : null}
                                        <Typography variant="body1" fontSize="0.875rem" lineHeight="20px">
                                          {cur['text']}
                                        </Typography>
                                      </Grid>
                                    )
                                  })}
                                </Stack>
                              </div>
                            }
                            {rating.important.length > 0 &&
                              <div className="summary-box important">
                                <Typography variant="h3" fontSize="2.25rem" mb="2.4rem" color="primary.main">
                                  {pageTitlesData?.data.attributes.Important}
                                </Typography>
                                <Stack direction="row" flexWrap="wrap" justifyContent="center">
                                  {rating.important.map((cur, index) => {
                                    return (
                                      <Grid item width='158px' sx={{ p: 2 }} textAlign="center">
                                        {cur['icon'] ?
                                          <Box className="icon-shape">
                                            <img className="values-icon" style={{ width: 50 }} src={cur['icon']} alt="" />
                                          </Box>
                                          : null}
                                        <Typography variant="body1" fontSize="0.875rem" lineHeight="20px">
                                          {cur['text']}
                                        </Typography>
                                      </Grid>
                                    )
                                  })}
                                </Stack>
                              </div>
                            }
                            {rating.lessImportant.length > 0 &&
                              <div className="summary-box less-important">
                                <Typography variant="h3" fontSize="2.25rem" mb="2.4rem" color="primary.main">
                                  {pageTitlesData?.data.attributes.LessImportant}
                                </Typography>
                                <Stack direction="row" flexWrap="wrap" justifyContent="center">
                                  {rating.lessImportant.map((cur, index) => {
                                    return (
                                      <Grid item width='158px' sx={{ p: 2 }} textAlign="center">
                                        {cur['icon'] ?
                                          <Box className="icon-shape">
                                            <img className="values-icon" style={{ width: 50 }} src={cur['icon']} alt="" />
                                          </Box>
                                          : null}
                                        <Typography variant="body1" fontSize="0.875rem" lineHeight="20px">
                                          {cur['text']}
                                        </Typography>
                                      </Grid>
                                    )
                                  })}
                                </Stack>
                              </div>
                            }
                            {rating.leastImportant.length > 0 &&
                              <div className="summary-box least-important">
                                <Typography variant="h3" fontSize="2.25rem" mb="2.4rem" color="primary.main">
                                  {pageTitlesData?.data.attributes.LeastImportant}
                                </Typography>
                                <Stack direction="row" flexWrap="wrap" justifyContent="center">
                                  {rating.leastImportant.map((cur, index) => {
                                    return (
                                      <Grid item width='158px' sx={{ p: 2 }} textAlign="center">
                                        {cur['icon'] ?
                                          <Box className="icon-shape">
                                            <img className="values-icon" style={{ width: 50 }} src={cur['icon']} alt="" />
                                          </Box>
                                          : null}
                                        <Typography variant="body1" fontSize="0.875rem" lineHeight="20px">
                                          {cur['text']}
                                        </Typography>
                                      </Grid>
                                    )
                                  })}
                                </Stack>
                              </div>
                            }
                          </div>

                          <div className="summary-box choice-ques stuff-value">
                            <Container maxWidth="md">
                              {rating.choiceOne.length > 0 &&
                                <>
                                  <Typography variant="h3" fontSize="2.25rem" mb="2.4rem" color="primary.main">
                                    {globalData?.data.attributes.question_content}
                                  </Typography>
                                  <Stack direction="row" spacing={4} justifyContent="center">
                                    <Grid item width='148px' sx={{ p: 2 }} textAlign="center">
                                      <Box className="icon-shape">
                                        <img className="values-icon" style={{ width: 50 }} src={rating.choiceOne[0]['icon']} alt="" />
                                      </Box>
                                      <Typography variant="body1" fontSize="0.875rem" lineHeight="20px">
                                        {lastQuestionChoices?.data.attributes.choiceOne}
                                      </Typography>
                                    </Grid>
                                  </Stack>
                                </>}
                              {rating.choiceTwo.length > 0 &&
                                <>
                                  <Typography variant="h3" fontSize="2.25rem" mb="2.4rem" color="primary.main">
                                    {globalData?.data.attributes.question_content}
                                  </Typography>
                                  <Stack direction="row" spacing={4} justifyContent="center">
                                    <Grid item width='148px' sx={{ p: 2 }} textAlign="center">
                                      <Box className="icon-shape">
                                        <img className="values-icon" style={{ width: 50 }} src={rating.choiceTwo[0]['icon']} alt="" />
                                      </Box>
                                      <Typography variant="body1" fontSize="0.875rem" lineHeight="20px">
                                        {lastQuestionChoices?.data.attributes.choiceTwo}
                                      </Typography>
                                    </Grid>
                                  </Stack>
                                </>}
                              {rating.choiceThree.length > 0 &&
                                <>
                                  <Typography variant="h3" fontSize="2.25rem" mb="2.4rem" color="primary.main">
                                    {globalData?.data.attributes.question_content}
                                  </Typography>
                                  <Stack direction="row" spacing={4} justifyContent="center">
                                    <Grid item width='148px' sx={{ p: 2 }} textAlign="center">
                                      <Box className="icon-shape">
                                        <img className="values-icon" style={{ width: 50 }} src={rating.choiceThree[0]['icon']} alt="" />
                                      </Box>
                                      <Typography variant="body1" fontSize="0.875rem" lineHeight="20px">
                                        {lastQuestionChoices?.data.attributes.choiceThree}
                                      </Typography>
                                    </Grid>
                                  </Stack>
                                </>}
                              {rating.choiceFour.length > 0 &&
                                <>
                                  <Typography variant="h3" fontSize="2.25rem" mb="2.4rem" color="primary.main">
                                    {globalData?.data.attributes.question_content}
                                  </Typography>
                                  <Stack direction="row" spacing={4} justifyContent="center">
                                    <Grid item width='148px' sx={{ p: 2 }} textAlign="center">
                                      <Box className="icon-shape">
                                        <img className="values-icon" style={{ width: 50 }} src={rating.choiceFour[0]['icon']} alt="" />
                                      </Box>
                                      <Typography variant="body1" fontSize="0.875rem" lineHeight="20px">
                                        {lastQuestionChoices?.data.attributes.choiceFour}
                                      </Typography>
                                    </Grid>
                                  </Stack>
                                </>}
                              {rating.choiceFive.length > 0 &&
                                <>
                                  <Typography variant="h3" fontSize="2.25rem" mb="2.4rem" color="primary.main">
                                    {globalData?.data.attributes.question_content}
                                  </Typography>
                                  <Stack direction="row" spacing={4} justifyContent="center">
                                    <Grid item width='148px' sx={{ p: 2 }} textAlign="center">
                                      <Box className="icon-shape">
                                        <img className="values-icon" style={{ width: 50 }} src={rating.choiceFive[0]['icon']} alt="" />
                                      </Box>
                                      <Typography variant="body1" fontSize="0.875rem" lineHeight="20px">
                                        {lastQuestionChoices?.data.attributes.choiceFive}
                                      </Typography>
                                    </Grid>
                                  </Stack>
                                </>

                              }

                            </Container>
                          </div>

                        </Grid>
                      }
                    </Grid>

                    <PageBreak key="break" />

                    <div style={{ backgroundColor: '#FAF6ED', height: '286mm' }}>
                      <Grid container item xl={12} lg={12} md={12} sx={{ alignItems: "center", justifyContent: "center", pt: 0, pb: 8 }}>
                        <Grid container item xs={12} sx={{ alignItems: "center", justifyContent: "space-between" }}>
                          {sameSection?.data != null && sameSection?.data != null ? (
                            <ChecklistQues quiz={sameSection} ButtonData={pageTitlesData} isPdfGeneration={isPdfGeneration} isloading={isloading} />
                          ) : null}
                        </Grid>
                      </Grid>
                    </div>

                  </>}
              </div>


              <CustomTabPanel value={value} index={0}>
                <Grid item xs={12} pl={!isMobile ? "0rem" : ""} pr={!isMobile ? "0rem" : ""} sx={{ alignItems: "center" }}>

                  <Container maxWidth="md">
                    <Typography variant="h3" color="primary.main" fontSize="2.25rem" fontWeight="500" style={{ marginBottom: '1rem' }}>
                      {pageTitlesData?.data.attributes.PdfMyValues}
                    </Typography>
                  </Container>
                  {rating &&
                    <Grid
                      container
                      columns={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}
                    >
                      <div className="summary-grid else-summary" >
                        {rating.mostImportant.length > 0 &&
                          <div className="summary-box most-important">
                            <Typography variant="h3" fontSize="2.25rem" mb="2.4rem" color="primary.main">
                              {pageTitlesData?.data.attributes.MostImportant}
                            </Typography>
                            <Stack direction="row" flexWrap="wrap" justifyContent="center">
                              {rating.mostImportant.map((cur, index) => {
                                return (
                                  <Grid item width='158px' sx={{ p: 2 }} textAlign="center">
                                    {cur['icon'] ?
                                      <Box className="icon-shape">
                                        <img className="values-icon" style={{ width: 50 }} src={cur['icon']} alt="" />
                                      </Box>
                                      : null}
                                    <Typography variant="body1" fontSize="0.875rem" lineHeight="20px">
                                      {cur['text']}
                                    </Typography>
                                  </Grid>
                                )
                              })}
                            </Stack>
                          </div>
                        }
                        {rating.important.length > 0 &&
                          <div className="summary-box important">
                            <Typography variant="h3" fontSize="2.25rem" mb="2.4rem" color="primary.main">
                              {pageTitlesData?.data.attributes.Important}
                            </Typography>
                            <Stack direction="row" flexWrap="wrap" justifyContent="center">
                              {rating.important.map((cur, index) => {
                                return (
                                  <Grid item width='158px' sx={{ p: 2 }} textAlign="center">
                                    {cur['icon'] ?
                                      <Box className="icon-shape">
                                        <img className="values-icon" style={{ width: 50 }} src={cur['icon']} alt="" />
                                      </Box>
                                      : null}
                                    <Typography variant="body1" fontSize="0.875rem" lineHeight="20px">
                                      {cur['text']}
                                    </Typography>
                                  </Grid>
                                )
                              })}
                            </Stack>
                          </div>
                        }
                        {rating.lessImportant.length > 0 &&
                          <div className="summary-box less-important">
                            <Typography variant="h3" fontSize="2.25rem" mb="2.4rem" color="primary.main">
                              {pageTitlesData?.data.attributes.LessImportant}
                            </Typography>
                            <Stack direction="row" flexWrap="wrap" justifyContent="center">
                              {rating.lessImportant.map((cur, index) => {
                                return (
                                  <Grid item width='158px' sx={{ p: 2 }} textAlign="center">
                                    {cur['icon'] ?
                                      <Box className="icon-shape">
                                        <img className="values-icon" style={{ width: 50 }} src={cur['icon']} alt="" />
                                      </Box>
                                      : null}
                                    <Typography variant="body1" fontSize="0.875rem" lineHeight="20px">
                                      {cur['text']}
                                    </Typography>
                                  </Grid>
                                )
                              })}
                            </Stack>
                          </div>
                        }
                        {rating.leastImportant.length > 0 &&
                          <div className="summary-box least-important">
                            <Typography variant="h3" fontSize="2.25rem" mb="2.4rem" color="primary.main">
                              {pageTitlesData?.data.attributes.LeastImportant}
                            </Typography>
                            <Stack direction="row" flexWrap="wrap" justifyContent="center">
                              {rating.leastImportant.map((cur, index) => {
                                return (
                                  <Grid item width='158px' sx={{ p: 2 }} textAlign="center">
                                    {cur['icon'] ?
                                      <Box className="icon-shape">
                                        <img className="values-icon" style={{ width: 50 }} src={cur['icon']} alt="" />
                                      </Box>
                                      : null}
                                    <Typography variant="body1" fontSize="0.875rem" lineHeight="20px">
                                      {cur['text']}
                                    </Typography>
                                  </Grid>
                                )
                              })}
                            </Stack>
                          </div>
                        }
                      </div>

                      <div
                       className="summary-box choice-ques stuff-value">
                        <Container maxWidth="md">
                          {rating.choiceOne.length > 0 &&
                            <>
                              <Typography variant="h3" fontSize="2.25rem" mb="2.4rem" color="primary.main">
                                {globalData?.data.attributes.question_content}
                              </Typography>
                              <Stack direction="row" spacing={4} justifyContent="center">
                                <Grid item width='158px' sx={{ p: 2 }} textAlign="center">
                                  {rating.choiceOne[0]['icon'] ?
                                    <Box className="icon-shape">
                                      <img className="values-icon" style={{ width: 50 }} src={rating.choiceOne[0]['icon']} alt="" />
                                    </Box>
                                    : null}
                                  <Typography variant="body1" fontSize="0.875rem" lineHeight="20px">
                                    {lastQuestionChoices?.data.attributes.choiceOne}
                                  </Typography>
                                </Grid>
                              </Stack>
                              <Link href="/MyStuff?tab=1" style={{ display: 'inline-block', marginTop: '3rem' }}>
                                <WhiteStyleButton variant="contained">{pageTitlesData?.data.attributes.Next}</WhiteStyleButton>
                              </Link>
                            </>}
                          {rating.choiceTwo.length > 0 &&
                            <>
                              <Typography variant="h3" fontSize="2.25rem" mb="2.4rem" color="primary.main">
                                {globalData?.data.attributes.question_content}
                              </Typography>
                              <Stack direction="row" spacing={4} justifyContent="center">
                                <Grid item width='158px' sx={{ p: 2 }} textAlign="center">
                                  {rating.choiceTwo[0]['icon'] ?
                                    <Box className="icon-shape">
                                      <img className="values-icon" style={{ width: 50 }} src={rating.choiceTwo[0]['icon']} alt="" />
                                    </Box>
                                    : null}
                                  <Typography variant="body1" fontSize="0.875rem" lineHeight="20px">
                                    {lastQuestionChoices?.data.attributes.choiceTwo}
                                  </Typography>
                                </Grid>
                              </Stack>
                              <Link href="/MyStuff?tab=1" style={{ display: 'inline-block', marginTop: '3rem' }}>
                                <WhiteStyleButton variant="contained">{pageTitlesData?.data.attributes.Next}</WhiteStyleButton>
                              </Link>
                            </>}
                          {rating.choiceThree.length > 0 &&
                            <>
                              <Typography variant="h3" fontSize="2.25rem" mb="2.4rem" color="primary.main">
                                {globalData?.data.attributes.question_content}
                              </Typography>
                              <Stack direction="row" spacing={4} justifyContent="center">
                                <Grid item width='158px' sx={{ p: 2 }} textAlign="center">
                                  {rating.choiceThree[0]['icon'] ?
                                    <Box className="icon-shape">
                                      <img className="values-icon" style={{ width: 50 }} src={rating.choiceThree[0]['icon']} alt="" />
                                    </Box>
                                    : null}
                                  <Typography variant="body1" fontSize="0.875rem" lineHeight="20px">
                                    {lastQuestionChoices?.data.attributes.choiceThree}
                                  </Typography>
                                </Grid>
                              </Stack>
                              <Link href="/MyStuff?tab=1" style={{ display: 'inline-block', marginTop: '3rem' }}>
                                <WhiteStyleButton variant="contained">{pageTitlesData?.data.attributes.Next}</WhiteStyleButton>
                              </Link>
                            </>}
                          {rating.choiceFour.length > 0 &&
                            <>
                              <Typography variant="h3" fontSize="2.25rem" mb="2.4rem" color="primary.main">
                                {globalData?.data.attributes.question_content}
                              </Typography>
                              <Stack direction="row" spacing={4} justifyContent="center">
                                <Grid item width='158px' sx={{ p: 2 }} textAlign="center">
                                  {rating.choiceFour[0]['icon'] ?
                                    <Box className="icon-shape">
                                      <img className="values-icon" style={{ width: 50 }} src={rating.choiceFour[0]['icon']} alt="" />
                                    </Box>
                                    : null}
                                  <Typography variant="body1" fontSize="0.875rem" lineHeight="20px">
                                    {lastQuestionChoices?.data.attributes.choiceFour}
                                  </Typography>
                                </Grid>
                              </Stack>
                              <Link href="/MyStuff?tab=1" style={{ display: 'inline-block', marginTop: '3rem' }}>
                                <WhiteStyleButton variant="contained">{pageTitlesData?.data.attributes.Next}</WhiteStyleButton>
                              </Link>
                            </>}
                          {rating.choiceFive.length > 0 &&
                            <>
                              <Typography variant="h3" fontSize="2.25rem" mb="2.4rem" color="primary.main">
                                {globalData?.data.attributes.question_content}
                              </Typography>
                              <Stack direction="row" spacing={4} justifyContent="center">
                                <Grid item width='158px' sx={{ p: 2 }} textAlign="center">
                                  {rating.choiceFive[0]['icon'] ?
                                    <Box className="icon-shape">
                                      <img className="values-icon" style={{ width: 50 }} src={rating.choiceFive[0]['icon']} alt="" />
                                    </Box>
                                    : null}
                                  <Typography variant="body1" fontSize="0.875rem" lineHeight="20px">
                                    {lastQuestionChoices?.data.attributes.choiceFive}
                                  </Typography>
                                </Grid>
                              </Stack>
                              <Link href="/MyStuff?tab=1" style={{ display: 'inline-block', marginTop: '3rem' }}>
                                <WhiteStyleButton variant="contained">{pageTitlesData?.data.attributes.Next}</WhiteStyleButton>
                              </Link>
                            </>

                          }

                        </Container>
                      </div>

                    </Grid>
                  }
                </Grid>

              </CustomTabPanel>

              <CustomTabPanel value={value} index={1}>
                <Container maxWidth="md">
                  <Grid xs={12} pl={!isMobile ? "1.5rem" : ""} pr={!isMobile ? "1.5rem" : ""}>
                    <Grid item xs={12} sx={{ alignItems: "center" }}>
                      {pageTitlesData?.data.attributes.Title != null ? (
                        <Typography variant="h3" color="primary.main" fontSize="2.25rem" fontWeight="500" style={{ marginBottom: '1rem' }}>
                          {pageTitlesData?.data.attributes.Title}
                        </Typography>
                      ) : null}
                      {pageTitlesData?.data.attributes.Description != null ? (
                        <Typography gutterBottom style={{ width: '100%', height: 'auto', fontSize: 16, fontWeight: 400, lineHeight: '24px', fontFamily: 'Public Sans' }} color="text.primary">
                          {pageTitlesData?.data.attributes.Description}
                        </Typography>
                      ) : null}
                    </Grid>
                    <Grid container item xl={12} lg={12} md={12} sx={{ alignItems: "center", justifyContent: "center", pt: 6, pb: 8 }}>
                      <Grid container item xs={12} sx={{ alignItems: "center", justifyContent: "space-between" }}>
                        {sameSection?.data != null ? (
                          <ChecklistQues quiz={sameSection} ButtonData={pageTitlesData} isPdfGeneration={isPdfGeneration} isloading={isloading} />
                        ) : null}
                      </Grid>
                    </Grid>
                    <Grid container item xl={12} lg={12} md={12} sx={{ alignItems: "center", justifyContent: "center", pt: 6, pb: 3 }}>
                      <Grid container item xs={12} sx={{ alignItems: "center", justifyContent: "center" }}>
                        <Typography variant="h3" fontSize="2.25rem" color="primary.main" fontWeight="500">{pageTitlesData?.data.attributes.QuestionLabel}</Typography>
                      </Grid>
                    </Grid>
                    <Grid container item xl={12} lg={12} md={12} sx={{ alignItems: "center", justifyContent: "center", pt: 0, pb: 8 }}>
                      <Grid container item xs={12} sx={{ alignItems: "center", justifyContent: "center" }}>
                        <Stack spacing={2} direction="row">
                          <Button className="save-ques-btn" onClick={handleClickOpen} variant="outlined"><img src={EnvelopeIcon} alt="Envelope Icon" />{pageTitlesData?.data.attributes.Button1}</Button>
                          <Button className="save-ques-btn" style={{ marginRight: 16, marginLeft: 0 }} variant="outlined" onClick={downloadSummary} ><img src={DownloadIcon} alt="Download Icon" />{pageTitlesData?.data.attributes.Button2}</Button>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Grid>
                </Container>

                <Dialog open={open} className="stuff-email-form" onClose={handleClose}>
                  <DialogTitle>{pageTitlesData?.data.attributes.QuestionLabel}</DialogTitle>
                  <DialogContent>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="name"
                      label="Email Address"
                      type="email"
                      fullWidth
                      variant="standard"
                      value={email}
                      onChange={handleEmailChange}
                      InputProps={{
                        error: !isEmailValid,
                      }}
                      helperText={isEmailValid ? '' : 'Invalid email format'}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleEmailSend}>Send</Button>
                  </DialogActions>
                </Dialog>

              </CustomTabPanel>
            </Grid>
          </Grid>
        </div>
      </Layout>
    </StyledEngineProvider>
  );
}